import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { MessageActions } from 'src/app/samwebDescription/samweb/messages/MessageActions';
import { MessageInfo } from 'src/app/store/samwin/samwin-mail-list/message-info';
import { EmailReaderWindowComponent } from '../email-reader-window/email-reader-window.component';

@Component({
   selector: 'samweb-email-reader-action-button',
   templateUrl: './email-reader-action-button.component.html',
   styleUrls: ['./email-reader-action-button.component.scss'],
})
export class EmailReaderActionButtonComponent implements OnInit {
   @Input()
   public messageInfo: MessageInfo;

   @Input()
   public messageId: string;

   @Input()
   public actionId: string;

   @Input()
   public iconOnly = true;

   @Input()
   public mainActionIds: string[] = _(MessageActions.getValues())
      .map((action) => action.value)
      .take(EmailReaderWindowComponent.actionDisplayLength)
      .value();

   public primaryIcon: IconDefinition;
   public secondaryIcon: IconDefinition;
   public actionTitleTranslation: string;

   public isMainAction: boolean;
   public isOtherAction: boolean;
   public isDeleteAction: boolean;

   constructor(public store: Store) {}

   ngOnInit() {
      const action = MessageActions[this.actionId];

      const isMain = _(this.mainActionIds).includes(this.actionId);
      this.isDeleteAction = action.enumName === MessageActions.DELETE.enumName;
      this.isMainAction = !this.isDeleteAction && isMain;
      this.isOtherAction = !this.isDeleteAction && !isMain;

      this.primaryIcon = action.defaultIcon;
      this.secondaryIcon = action.subIcon;

      this.actionTitleTranslation = action.translationValue;
   }

   executeAction(actionId: string) {
      MessageActions[actionId].executeAction$(this.store, this.messageInfo);
   }
}
